import React from "react";
import { Languages, Check, ChevronDown } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { LANGS } from "@/i18n";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from "@/components/ui/dropdown-menu";

const NAMES = { hu: "Magyar", en: "English", de: "Deutsch", fr: "Français", cs: "Čeština" };

export function LangMenu({ className = "" }) {
  const { lang, setLang } = useLang();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="lang-menu"
          className={`flex items-center gap-1.5 rounded-md border border-zinc-800 bg-zinc-900/60 px-2.5 py-1.5 text-[12px] font-semibold text-zinc-300 transition-colors hover:bg-zinc-800 hover:text-zinc-100 ${className}`}
        >
          <Languages size={14} className="text-zinc-400" />
          <span>LANG</span>
          <span className="text-zinc-500">· {lang.toUpperCase()}</span>
          <ChevronDown size={13} className="text-zinc-500" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[150px] border-zinc-800 bg-zinc-900 text-zinc-200">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l}
            data-testid={`lang-${l}`}
            onClick={() => setLang(l)}
            className="flex cursor-pointer items-center justify-between text-[13px] focus:bg-zinc-800"
          >
            <span><span className="font-semibold uppercase">{l}</span> · {NAMES[l] || l}</span>
            {lang === l && <Check size={14} className="text-blue-400" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
